export class Cloud {
	x: number;
	y: number;
	scale: number;
	speed: number;

	constructor(x: number, y: number, scale: number = 1, speed: number = 0.2) {
		this.x = x;
		this.y = y;
		this.scale = scale;
		this.speed = speed;
	}

	update(): void {
		// Bulutlar yavaşça sağa hareket eder
		this.x += this.speed;

		// Ekrandan çıkınca soldan geri gel
		if (this.x > 1200) {
			this.x = -100;
		}
	}

	draw(): void {
		push();
		translate(this.x, this.y);
		scale(this.scale);

		noStroke();
		fill(255, 255, 255, 230);

		// Bulut şekli - üst üste binmiş elipsler
		ellipse(0, 0, 60, 40);
		ellipse(20, -5, 50, 35);
		ellipse(40, 0, 55, 38);
		ellipse(10, 10, 45, 30);
		ellipse(30, 8, 40, 28);

		pop();
	}
}

export class CloudManager {
	clouds: Cloud[] = [];

	constructor() {
		// Farklı pozisyon, boyut ve hızlarda bulutlar oluştur
		// Y değerleri: 150-250 arası (ağaç ve dağ seviyesine yakın)
		this.clouds = [
			new Cloud(100, 180, 0.8, 0.15),
			new Cloud(300, 220, 1.2, 0.25),
			new Cloud(500, 160, 0.6, 0.1),
			new Cloud(700, 240, 1.0, 0.2),
			new Cloud(900, 200, 0.9, 0.18),
		];
	}

	update(): void {
		for (const cloud of this.clouds) {
			cloud.update();
		}
	}

	draw(): void {
		for (const cloud of this.clouds) {
			cloud.draw();
		}
	}

	reset(): void {
		this.clouds = [
			new Cloud(100, 180, 0.8, 0.15),
			new Cloud(300, 220, 1.2, 0.25),
			new Cloud(500, 160, 0.6, 0.1),
			new Cloud(700, 240, 1.0, 0.2),
			new Cloud(900, 200, 0.9, 0.18),
		];
	}
}
